import { useEffect, useMemo, useState } from 'react'
import axios from 'axios'
import { format } from 'date-fns'
import ReactGA from 'react-ga4'
import { useNavigate, useParams } from 'react-router-dom'
import { AppConstants, LeadStage } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import { useAppDispatch, useAppSelector } from 'redux/store'
import styles from './Congrats.module.scss'

enum Device_Type {
  ios = 'IOS',
  android = 'Android',
  desktop = 'Desktop',
}

const CongratsBooking = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const appointmentTime = useAppSelector((state) => state.booking.selectedSlotBooking)
  const referralCode = useAppSelector((state) => state.booking.referralCodeBooking)
  const [device, setDevice] = useState('')
  const studios = useAppSelector((state) => state.booking.studiosBooking)
  const selectedStudio = useAppSelector((state) => state.booking.selectedStudioBooking)
  const isMoreThanOneStudio = useAppSelector((state) => state.booking.isMoreThanOneStudioBooking)
  const firstname = useAppSelector((state) => state.booking.firstname)
  const channelBooking = useAppSelector((state) => state.booking.channel)
  const plans = useAppSelector((state) => state.booking.availablePlansBooking)

  const plan = useMemo(() => {
    if (plans) {
      const filterOnDemand = plans?.filter((p) => p.type === 'on-demand')
      return filterOnDemand
    } else {
      return null
    }
  }, [plans])

  useEffect(() => {
    const userAgent = navigator.userAgent

    const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent)

    if (isMobile) {
      if (/iPad/i.test(userAgent)) {
        setDevice(Device_Type.ios)
      } else if (/iPhone/i.test(userAgent)) {
        setDevice(Device_Type.ios)
      } else if (/Android/i.test(userAgent)) {
        setDevice(Device_Type.android)
      }
    } else {
      setDevice(Device_Type.desktop)
    }
  }, [])

  const toAppStore = () => {
    window.location.href = `https://apps.apple.com/us/app/kiro-chiropractic-adjustments/id6475482372`
  }

  const toPlayStore = () => {
    window.location.href = `https://play.google.com/store/apps/details?id=com.getkiro.kiro`
  }

  const postLeadStage = async () => {
    await axios
      .post(
        AppConstants.API_URL + '/lead/stage/update',
        { stage: LeadStage.done, channel: channelBooking },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        },
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err?.response
      })
  }

  useEffect(() => {
    postLeadStage()
  }, [])
  useEffect(() => {
    ReactGA.event('page_view', {
      page_title: 'booking|Welcome',
      page_location: `/booking/${id}/welcome`,
    })
  }, [])

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div style={{ display: 'flex', flexDirection: 'column', position: 'absolute', left: '16px', top: '26px' }}>
            <span style={{ textTransform: 'capitalize' }}>{`Congrats, ${firstname}! `}</span>
            <span>{`Your booking is confirmed.`}</span>
          </div>
          <img src={'/logo2.png'} alt="logo" className={styles.logo} />
          <div style={{ marginTop: '40px' }}></div>
        </div>
        <div className={styles.locationContainer}>
          <div className={styles.confirmHeader}>
            Please <b>download the KIRO app</b> below: you'll <br></br> need it to check in at the studio and to make
            any changes to your appointment.&nbsp;
            {plan && plan[0]?.amount === 0
              ? 'Please also review our free booking policy below.'
              : 'Please also review our appointment change policy below.'}
          </div>
          <div className={styles.appointmentDetailsHeader}>Appointment Details</div>
          {studios && (
            <div className={styles.locationDetails}>
              <div className={styles.locationTextContainer}>
                <div className={styles.locationWrapper}>
                  <div className={styles.appointmentTime}>
                    {appointmentTime
                      ? format(new Date(appointmentTime?.scheduleObject.appointmentTime), 'EEEE, MMM dd')
                      : ''}
                    <div>
                      {appointmentTime
                        ? format(new Date(appointmentTime?.scheduleObject.appointmentTime), 'h:mm a')
                        : ''}
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: 400 }}>Exam + Adjustment</div>
                  </div>
                  <div>
                    <div className={styles.locationText} style={{ fontWeight: 700 }}>
                      {isMoreThanOneStudio ? selectedStudio?.name : studios[0]?.name}
                    </div>
                    <div className={styles.locationText}>
                      {isMoreThanOneStudio ? selectedStudio?.address : studios[0]?.address}
                    </div>
                    {isMoreThanOneStudio ? (
                      <div className={styles.cityAndState}>
                        <div style={{ marginRight: '4px' }}>{selectedStudio?.city.name + ','}</div>
                        <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{selectedStudio?.state}</div>
                        <div>{selectedStudio?.zipCode}</div>
                      </div>
                    ) : (
                      <div className={styles.cityAndState}>
                        <div style={{ marginRight: '4px' }}>{studios[0]?.city.name + ','}</div>
                        <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{studios[0]?.state}</div>
                        <div>{studios[0]?.zipCode}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <img
                style={{ width: '145px', height: '150px', cursor: 'pointer', objectFit: 'cover' }}
                className={styles.mapImageItem}
                src={isMoreThanOneStudio ? selectedStudio?.mapImage || '' : studios[0]?.mapImage || ''}
                alt="map"
                onClick={() => {
                  if (studios && selectedStudio && selectedStudio?.mapLocation && isMoreThanOneStudio) {
                    window.open(selectedStudio.mapLocation, '_blank')
                  } else if (studios && studios.length === 1 && studios[0]?.mapLocation) {
                    window.open(studios[0].mapLocation, '_blank')
                  }
                  //   window.location.href =
                  //     'https://www.google.com/maps/place/302+Mott+St,+New+York,+NY+10012,+USA/@40.7248592,-73.9940347'
                }}
              />
            </div>
          )}
        </div>
        {plan && plan[0]?.amount !== 0 && (
          <div className={styles.cancellationPolicy}>
            <div className={styles.policyHeader}>Appointment Change Policy</div>
            <div className={styles.cancellation}>
              <strong>Cancellations:</strong> Cancellations made at least 12 hours before the appointment time will not
              incur a fee. Cancellations made between 12 hours and 1 hour before the appointment will incur a $10 fee,
              and those made less than 1 hour before, or in the case of a no-show, will incur a $20 fee. <br></br>
              <br></br>
              <strong>Same-Day Reschedules:</strong> Appointments can be rescheduled for the same day at no charge if
              done at least 1 hour in advance. Same-day reschedules made within 1 hour of the appointment time will
              incur a $20 short-notice fee.<br></br>
              <br></br>
              These policies ensure fair access for all Members and allow our doctors to provide care to other patients
              in need.
            </div>
          </div>
        )}
        {plan && plan[0]?.amount === 0 && referralCode && (
          <div className={styles.cardRequiredPolicy}>
            <div className={styles.policyHeader}>Free Booking Policy</div>
            <div className={styles.cardRequired}>
              No-shows or cancellations will result in a $40 non-refundable charge. This policy ensures fair access to
              slots for all patients while respecting our doctors' time.
            </div>
          </div>
        )}
        <Footer
          buttonText={'Download KIRO'}
          isLoading={false}
          // trackerIndex={referralCode === null ? 5 : 4}
          // shouldShowFive={referralCode === null ? true : false}
          trackerIndex={referralCode === null ? (isMoreThanOneStudio ? 5 : 4) : isMoreThanOneStudio ? 4 : 3}
          shouldShowFour={!isMoreThanOneStudio && referralCode ? false : true}
          shouldShowFive={referralCode === null && isMoreThanOneStudio ? true : false}
          isDisabled={false}
          buttonType={'button'}
          onButtonClick={() => {
            if (device === Device_Type.android) {
              toPlayStore()
            } else if (device === Device_Type.ios) {
              toAppStore()
            } else {
              navigate(`/booking/${id}/download`)
            }
          }}
        ></Footer>
      </div>
    </>
  )
}

export default CongratsBooking
